export default __webpack_public_path__ + "static/media/info-orange.d765ce13.svg";